import {IdIsimDto} from './id-isim-dto';
import {KullaniciSube} from './kullanici-sube';

export class Kullanici {

  id: number;
  kullaniciAdi: string;
  getProfilePic: string;
  typeName = '';
  adSoyad: string;
  pSubeler: IdIsimDto[];
  epostaAdresi: string;
  kullaniciGrup: IdIsimDto;
  sifre: string;
  kullaniciGrupId: number;
  pKullaniciSubeler: KullaniciSube[];
  vkn: string;

  constructor(obj?: any) {
    if (obj == null) {
      return;
    }
    Object.assign(this, obj);

    if (obj.kullaniciGrup != null) {
      this.kullaniciGrup = new IdIsimDto(obj.kullaniciGrup);
    }
  }

  public get subeler(): IdIsimDto[] {
    return this.pSubeler;
  }

  public set subeler(subeler: IdIsimDto[]) {
    if (subeler != null) {
      this.pSubeler = subeler.map(t => new IdIsimDto(t));
    }
  }

  public get kullaniciSubeler(): KullaniciSube[] {
    return this.pKullaniciSubeler;
  }

  public set kullaniciSubeler(items: KullaniciSube[]) {
    if (items != null) {
      this.pKullaniciSubeler = items.map(t => new KullaniciSube(t));
    }
  }
}
